import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import { useModal } from '../../../hooks/use-modal';
import * as Api from '../../../store/csw/csw.api';
import * as Actions from '../../../store/csw/csw.actions';

import ModalPortal from '../../modal-portal';
import { DeletePackageSetModal } from '../delete-package-set-modal';
import { MULTI_PACKAGE_APPLY_PACKAGE_SET_DELETED } from '../../../constants/analytics-events';
import { Segment } from '../../../services/analytics-services/segment';

export const DeletePackageSetModalWrapper = ({ children }) => {
  const { isOpen, open, close } = useModal();
  const [packageSetId, setPackageSetId] = useState();
  const [packageSetName, setPackageSetName] = useState();
  const openModal = (setId, setName) => {
    setPackageSetId(setId);
    setPackageSetName(setName);
    open();
  };

  const trackDeletePackageSet = () => {
    Segment.trackEvent(MULTI_PACKAGE_APPLY_PACKAGE_SET_DELETED, {
      type: MULTI_PACKAGE_APPLY_PACKAGE_SET_DELETED,
      packageSetId,
      packageSetName,
    });
  };

  const dispatch = useDispatch();
  const onDeletePackageSet = () => {
    Api.deletePackageSet(packageSetId)
      .then(() => {
        trackDeletePackageSet();
        close();
        dispatch(Actions.deletePackageSetSuccess(packageSetId));
      })
      .catch(() => {
        // TODO: handle error
      });
  };
  return (
    <>
      {children({ openModal })}
      {isOpen && (
        <ModalPortal onClose={close}>
          <DeletePackageSetModal onDeletePackageSet={onDeletePackageSet} />
        </ModalPortal>
      )}
    </>
  );
};

DeletePackageSetModalWrapper.propTypes = {
  children: PropTypes.func.isRequired,
};
